/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { SiteStructure } from "./data-contracts";

/**
 * @description Get the complete structure of a site that includes all its site-sections and site-spaces.
 * @tags site-structure
 * @name GetSiteStructure
 * @summary Get a site structure
 * @request GET:/orgs/{organizationId}/sites/{siteId}/structure
 * @secure
 */

// @ts-ignore
export const getSiteStructure: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** For sites published via share-links, the share key is useful to resolve published URLs. */
    shareKey?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteStructure;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/structure",
  method: "get",
  streaming: false,
  tags: ["site-structure"],
  criticalityLevel: "low",
  deprecated: false,
};
